import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-static-notifications',
    templateUrl: './dialog-static-notifications.component.html',
    styles: [],
    standalone: false
})
export class DialogStaticNotificationsComponent implements OnInit {
  public isMobile: boolean;
  constructor(
    public dialogRef: MatDialogRef<DialogStaticNotificationsComponent>,
    @Inject(MAT_DIALOG_DATA) public data
    ) {
      this.isMobile = environment.platform === 'mobile';
    }

  ngOnInit() {
  }

  // onNoClick(): void {
  //   this.dialogRef.close();
  // }

}

